import Header from './header';
import {useUsersStore} from './UsersStore';
import MessageInfo from '../../messageInfo';
import List from './list';
import MessageAutoTie from './messageAutoTie';

function UsersView() {
  const {state: usersStore} = useUsersStore();

  return (
    <>
      {usersStore.loading && <div className="loading-overlay"/>}

      <Header/>

      <div className="card">
        <MessageInfo message="organisationSetting.cantModifyRole"/>

        <MessageAutoTie/>

        <List/>
      </div>
    </>
  );
}

export default UsersView;
